module.exports = new __parcel__URL__("20458_sq.f3917c5a.jpg").toString();